module.exports = __webpack_public_path__ + "img/reject.6dc4f947.svg";